/*--------------------------------------------------------------
## Theme script
##
## Ver 1.0.4
## Template: _bs_underscore
--------------------------------------------------------------*/

 /*
  * Cookie handling
  */
 window.setCookie = function (key, value, hourExpires) {
    var expires = new Date();
    hourExpires = undefined === hourExpires ? 24 : hourExpires;
    
    expires.setTime(expires.getTime() + (hourExpires * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=/';
};

window.getCookie = function (key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
};

window.delCookie = function (key) {
    document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
};



jQuery( function( $ ) {
  
  
    $('.scroll').on('click', function (e) {
        e.preventDefault();
        // Change your offset according to your navbar height
        $( 'html, body' ).animate( { scrollTop: $( $(this).attr( 'href' ) ).offset().top - 55 }, 500, 'swing' );
    });

    /*
    if (window.location.hash) {
        // Change your offset according to your navbar height
        $('html, body').animate({ scrollTop: $(window.location.hash).offset().top - 55 }, 500, 'swing');
    }
    */

    $( window ).on('scroll', function () {
        const scroll = $( window ).scrollTop();

        if (scroll >= 500) {
            $( '.top-button' ).addClass( 'visible' );
        } else {
            $( '.top-button' ).removeClass( 'visible' );
        }
    });

    // Add offcanvas status to body class
    $( '#offcanvas-navbar' ).on( 'hide.bs.offcanvas', function() {
        $( 'body' ).removeClass( 'offcanvas-show' )
    });

    $('#offcanvas-navbar').on( 'show.bs.offcanvas', function() {
        $('body').addClass( 'offcanvas-show' );
    });



     // CF7 Select Box with attr first-as-label
     var $select = $( 'select.ce-first-as-label' );

     if ( $select.length ) {
       
        $select.attr( 'data-first-as-label', 0 === $select[0].selectedIndex ); // Set attr with true|false
 
        $select.on( 'change keyup', function() {
            //( $( this).val()=="" ) ? $(this).css( {color: "var(--ce-input-placeholder-color)"} ) : $( this ).css( {color: "var(--ce-input-color)"} );
            $(this).attr( 'data-first-as-label', 0 === $( this )[0].selectedIndex ); // Set attr with true|false
        });
    }

    function showLabelInline() {
        let $cf7 = $( '.wpcf7-form .ce-show-inline-label');
        let $controlWrap = $cf7.find( '.wpcf7-form-control-wrap' );

        $controlWrap.each( function() {
            let $formControl = $( this ).find( '.wpcf7-form-control' );
            let placeholder  = $formControl.attr( 'placeholder' );
            let id           = $formControl.attr( 'id' );
            
            if ( $formControl.is( 'select' ) && $formControl.hasClass( 'ce-first-as-label' ) ) {
                placeholder = $formControl.find('option').first().text();
            }

            if ( placeholder ) {
                $( this ).prepend( `<label for="${id}" class="inline">${placeholder}</label> `);
            }

            $formControl.on('keyup change', function() {
                let inlineLabel =  $( this ).closest( '.wpcf7-form-control-wrap' ).find( 'label.inline' );

                if( $( this ).val() ) {
                    inlineLabel.fadeIn();
                } else {
                    inlineLabel.fadeOut();
                }
            });

        });
    };

    showLabelInline();



    $( 'a.comment-reply-link' ).on( 'click', function() {
        if ( $ ('#collapseCommentReply.collapse' ).length ) {
            
        }
    });

    // commentform handling when collapsed
    if ( $ ( '#collapseCommentReply.collapse' ).length ) {
        let urlParams = getUrlHashParams();

        if ( urlParams['replytocom'] ) {
            new bootstrap.Collapse( $( '#collapseCommentReply') );
        }

    }




    // Get an object with current url params    
    function getUrlHashParams( ) {
        const href = window.location.href;
        const params = href.split('?')[1];
    
        if (params && params !== '') {
            const result = params.split( '&' ).reduce( function ( res, item ) {
                const parts = item.split( '=' );
                res[ parts[0] ] = parts[1];
                return res;
            }, {} );
    
            return result;
        }

        return {};
    }
           
   
    var dateInputMask = function dateInputMask( elm ) {
        
        if ( elm === undefined  ) {
            return;
        }

        elm.addEventListener( 'keypress', function( e ) {

        if ( e.keyCode < 46 || e.keyCode > 57 ) {
            e.preventDefault();
        }
        
        var len = elm.value.length;

        if ( len > 9 ) {
            e.preventDefault();
        }
        
        // If we're at a particular place, let the user type the slash
        // i.e., 01.12.1212
        if ( len !== 1 || len !== 3 ) {

            if ( e.keyCode == 46 ) {
                e.preventDefault();
            }
        }
        
        // If they don't add the slash, do it for them...
        if ( len === 2 ) {
        elm.value += '.';
        }

        // If they don't add the slash, do it for them...
        if ( len === 5 ) {
            elm.value += '.';
        }
    });
    };
  
    
    dateInputMask( document.querySelectorAll('input.ce-validate-date')[0] );

    
 }); // end .ready()

 


jQuery(function ($) {
    // Close offcanvas on click a, keep .dropdown-menu open
    $('.offcanvas a:not(.dropdown-toggle):not(a.remove_from_cart_button), a.dropdown-item').on('click', function () {
        $('.offcanvas').offcanvas('hide');
    });

   
    /*
    Ugly animation effects
     // Dropdown menu animation
    // Add slideDown animation to Bootstrap dropdown when expanding.
    $('.dropdown').on('show.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });
    

    // Add slideUp animation to Bootstrap dropdown when collapsing.
    
    $('.dropdown').on('hide.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
    });

    */


    // Search collapse button hide if empty
    if ($('#collapse-search').children().length == 0) {
        $('.top-nav-search-md, .top-nav-search-lg').remove();
    }

    // Searchform focus
    $('#collapse-search').on('shown.bs.collapse', function () {
        $('.top-nav-search input:first-of-type').focus();
    });

    // Close collapse if searchform loses focus
    $('.top-nav-search input:first-of-type').focusout(function () {
        $('#collapse-search').collapse('hide');
    });


  
/*

    adjustPrimaryTop = function() {
        if ( $( 'body.header-fixed' ).length ){
            let $wpadminbar = $( '#wpadminbar' ).height() ?? 0;
            let $navMainWrapper   = $( '#nav-main-wrapper' );
            let paddingTop =  $navMainWrapper.offset().top  + $navMainWrapper.outerHeight() -  $wpadminbar;
        
            $( '#primary' ).css( "padding-top", paddingTop );
        }
    }

    adjustPrimaryTop();
    $(window).on("resize", function() { adjustPrimaryTop() } );
    */
    

}); // jQuery End



/*
* If header fixed and containing transparent styling then set then body position top: -headerHeight
*/
document.addEventListener('DOMContentLoaded', (event) => {
    let bodyFixed = document.querySelector('body.header-fixed');
    
    
    if ( bodyFixed && bodyFixed.classList.toString().match(/ light| dark/)) {

        // Don't handle header height 
        if ( bodyFixed.classList.contains( 'no-heading-offset-height' ) ) {
            return;
        }

        let headerHeight = document.getElementById('main-header').offsetHeight;
        let page = document.getElementById('page');
      
        page.style.paddingTop = headerHeight + 'px';

        
    }
});



const scroller = document.addEventListener("scroll", (event) => {
    const scrollY = document.documentElement.scrollTop;
    const body = document.querySelector('body');

   if ( scrollY === 0 ) {
    body.classList.remove('scrolled-down' );
       

    } else {
        body.classList.add('scrolled-down' );
    }
});



